import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../../shared/services/http.service';
import { ILoginRequest } from './login.model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http : HttpService ) {

   }


   public login(url : string , requestObj : ILoginRequest) : Observable<any>{
   return this.http.postApi(url , requestObj).pipe(map((response) =>{
     return response;
   }))
   }



}
